var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1280.000000pt",
    height: "722.000000pt",
    viewBox: "0 0 1280.000000 722.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,722.000000) scale(0.100000,-0.100000)",
    fill: "#555555",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1905 7210 l-1300 -7 -73 -27 c-208 -77 -364 -219 -476 -435 l-56 -109 0 -222 0 -222 64 -132 64 -131 2348 -2345 c2607 -2604 3307 -3298 3436 -3411 144 -126 233 -159 440 -166 179 -7 307 12 384 56 139 80 273 211 3558 3491 l2379 2375 63 131 64 132 0 221 0 221 -46 93 c-110 219 -252 358 -451 439 -76 31 -82 32 -293 40 -307 10 -8552 17 -10105 8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDown);
export default __webpack_public_path__ + "static/media/sort-down.f81baac102ad31792d212222e34af411.svg";
export { ForwardRef as ReactComponent };